import { FormInput } from "../../../../../../components/ui/Input/FormInput/FormInput";
import { FormSearchSelect } from "../../../../../../components/ui/Input/FormSearchSelect/FormSearchSelect";
import { validateCharacterLength } from "../../../../../../utils/utils";
import TransportReferenceDataError from "../../externalTransport/components/TransportReferenceDataError";
import { InternalTransportIdentificationSectionProps } from "../internalTransport.types";

const InternalTransportIdentificationSection = ({
  control,
  disabled,
  transportationTypes,
  typesLoading,
  typesError,
  onRetryTypes,
  nameDisabled = false
}: InternalTransportIdentificationSectionProps) => (
  <div className="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-4 md:tw-grid-cols-2">
    <FormInput
      control={control}
      name="internalTransportName"
      label="Internal Transportation Name"
      placeholder="e.g. Yeast Transport"
      required
      disabled={disabled || nameDisabled}
      errorMessage="Internal Transport Name is required"
      rules={{
        validate: (value: string) =>
          validateCharacterLength(value, 32, "Internal Transportation Name cannot exceed 32 characters") ||
          true
      }}
    />
    {typesError ? (
      <TransportReferenceDataError
        message="Transportation types could not be loaded — retry"
        onRetry={onRetryTypes}
      />
    ) : (
      <FormSearchSelect
        control={control}
        name="transportationType"
        label="Transportation Type"
        placeholder="Select transportation type"
        options={(transportationTypes ?? []).map(type => ({
          id: type.key,
          title: type.text,
          value: type.value
        }))}
        required
        disabled={disabled || typesLoading}
        loading={typesLoading}
        errorMessage="Transportation type is required"
      />
    )}
  </div>
);

export default InternalTransportIdentificationSection;
